import { useTranslation } from 'react-i18next'

import { Lightning } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { FormatNumber, FormatPrice, Text } from '@reveni-io/reveni-ui'

import { statisticOrientations } from '@/common/components/Statistic/constants'
import TableHeaderButton from '@/metrics/components/TableHeaderButton/TableHeaderButton'
import { orderByValues } from '@/metrics/hooks/useFilters/constants'

import RefundMethodsTotals from '../RefundMethodsTotals/RefundMethodsTotals'
import * as Styles from './styles'

const RefundMethodsTable = ({ refundMethods, totalRefunds, totalAmount, showTotal, currency, onSort, orderBy }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const isGroupBySelected = (currentFilter, selectedFilter) => {
    const currentFilterWithoutOrdering = currentFilter?.replace('-', '')

    return currentFilterWithoutOrdering === selectedFilter
  }

  return (
    <Styles.Container>
      <Styles.TableHeader>
        <div>
          <Text type="allCapsS">{t('Método de reembolso')}</Text>
        </div>
        <div>
          <Styles.TableHeaderItem>
            <TableHeaderButton
              onClick={() => onSort(orderByValues.refunds)}
              selected={isGroupBySelected(orderBy, orderByValues.refunds)}
              direction={orderBy?.startsWith('-') ? 'desc' : 'asc'}
            >
              <Text type="allCapsS">{t('Devoluciones')}</Text>
            </TableHeaderButton>
          </Styles.TableHeaderItem>
          <Styles.TableHeaderItem minWidth="50px">
            <TableHeaderButton
              onClick={() => onSort(orderByValues.ratio)}
              selected={isGroupBySelected(orderBy, orderByValues.ratio)}
              direction={orderBy?.startsWith('-') ? 'desc' : 'asc'}
            >
              <Text type="allCapsS">%</Text>
            </TableHeaderButton>
          </Styles.TableHeaderItem>
          <Styles.TableHeaderItem minWidth="105px">
            <TableHeaderButton
              onClick={() => onSort(orderByValues.amount)}
              selected={isGroupBySelected(orderBy, orderByValues.amount)}
              direction={orderBy?.startsWith('-') ? 'desc' : 'asc'}
            >
              <Text type="allCapsS" customStyles={{ alignItems: 'right' }}>
                {t('Importe')}
              </Text>
            </TableHeaderButton>
          </Styles.TableHeaderItem>
        </div>
      </Styles.TableHeader>
      <Styles.RefundMethodsListContainer>
        {refundMethods?.map((refundMethod, index) => (
          <Styles.RefundMethodContainer key={index}>
            <Styles.RefundMethodLeftCol>
              <Text type="bodyMRegular" color={theme.colors.text.subtle} customStyles={{ width: '9px' }}>
                {index + 1}
              </Text>
              <Styles.RefundMethodBullet backgroundColor={refundMethod.bulletColor} />
              <refundMethod.Icon type={refundMethod.iconType} color={refundMethod.bulletColor} />
              <Styles.RefundMethodNameContainer>
                <Text type="bodyMBold">{t(refundMethod.label)}</Text>
                {refundMethod.isInstant && (
                  <>
                    <Lightning size={16} weight="fill" color={theme.colors.accent.hover} />
                    <Text type="bodySRegular" color={theme.colors.accent.hover}>
                      {t('Instantáneo')}
                    </Text>
                  </>
                )}
              </Styles.RefundMethodNameContainer>
            </Styles.RefundMethodLeftCol>
            <Styles.RefundMethodRightCol>
              <Styles.RefundMethodStatCol>
                <Text type="bodyMRegular">
                  <FormatNumber style="decimal">{refundMethod.count}</FormatNumber>
                </Text>
              </Styles.RefundMethodStatCol>
              <Styles.RefundMethodStatCol minWidth="50px">
                <Text type="bodyMRegular">
                  <FormatNumber style="percent">{refundMethod.percentage}</FormatNumber>
                </Text>
              </Styles.RefundMethodStatCol>
              <Styles.RefundMethodStatCol minWidth="105px">
                <Text type="bodyMRegular">
                  <FormatPrice currency={currency}>{refundMethod.amount}</FormatPrice>
                </Text>
              </Styles.RefundMethodStatCol>
            </Styles.RefundMethodRightCol>
          </Styles.RefundMethodContainer>
        ))}
      </Styles.RefundMethodsListContainer>
      {showTotal && (
        <Styles.TotalsContainer>
          <RefundMethodsTotals
            totalRefunds={totalRefunds}
            totalAmount={totalAmount}
            currency={currency}
            orientation={statisticOrientations.horizontal}
          />
        </Styles.TotalsContainer>
      )}
    </Styles.Container>
  )
}

export default RefundMethodsTable
